import { render, staticRenderFns } from "./TaskFromUser.vue?vue&type=template&id=2f7e69e0&scoped=true&"
import script from "./TaskFromUser.vue?vue&type=script&lang=js&"
export * from "./TaskFromUser.vue?vue&type=script&lang=js&"
import style0 from "./TaskFromUser.vue?vue&type=style&index=0&id=2f7e69e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7e69e0",
  null
  
)

export default component.exports